import * as signalR from "@microsoft/signalr";

let hubConnection = null;

export const initSignalR = (onCountUpdate) => {
  // 先清理旧连接（避免冲突）
  if (hubConnection) {
    hubConnection.stop().catch((err) => console.log("关闭旧连接：", err));
    hubConnection = null;
  }
  console.log("SignalR进来了");
  // 重新创建连接（重点：协商阶段相关配置）
  hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(
      "https://apicloud.bodor.com/hubs/dailyActivity", //?userId=" + "664010545@qq.com",
      {
        // 可选：禁用协商缓存（避免旧协商结果干扰）
        skipNegotiation: false, // 默认 false（必须协商，不能设为 true）
        headers: {
          token: "",
          //localStorage.getItem("token"),
        },
        transport:
          //signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling, // 允许两种传输方式
      },
    )
    .withAutomaticReconnect([1000, 3000, 5000]) // 延迟重连（避免协商请求频繁失败）
    .build();

  // 监听协商/连接相关事件（辅助调试）
  hubConnection.onclose((error) => {
    console.log("连接关闭：", error?.message || error);
  });

  hubConnection.onreconnecting((error) => {
    console.log("正在重连（协商阶段可能失败）：", error?.message || error);
  });

  // 监听人数更新
  hubConnection.on("ReceiveOnlineCount", onCountUpdate);

  // 启动连接（避免重复启动）
  if (hubConnection.state === signalR.HubConnectionState.Disconnected) {
    hubConnection
      .start()
      .then(() => console.log("SignalR 连接成功（协商+连接完成）"))
      .catch((err) => {
        console.error("SignalR 连接失败（协商阶段）：", err);
        // 协商失败后延迟重试（避免瞬间重复请求）
        setTimeout(() => initSignalR(onCountUpdate), 3000);
      });
  }
};

export const closeSignalR = async () => {
  if (
    hubConnection &&
    hubConnection.state !== signalR.HubConnectionState.Disconnected
  ) {
    await hubConnection.stop();
    hubConnection = null;
  }
};
